<template>
    <div class="container">
        <img class="img" src="../images/success.png" alt="" srcset="" />
        <div class="title">注册成功</div>
        <div class="sub">恭喜您，注册成功，快去创建小程序店铺吧~</div>
        <el-button class="btn" @click="onClick">创建店铺</el-button>
    </div>
</template>
<script>
export default {
    name: 'RegisterSuccess',
    methods: {
        onClick() {
            this.$router.push({ path: '/any/decorate' });
        }
    }
};
</script>
<style lang="scss" scoped>
.container {
    text-align: center;
    .img {
        width: 72px;
        height: 72px;
        vertical-align: top;
    }
    .title {
        margin-top: 24px;
        font-size: 24px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 32px;
    }
    .sub {
        margin-top: 8px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.43);
        line-height: 22px;
    }
    .btn {
        margin-top: 40px;
        background: #ff585e;
        color: #fff;
        width: 335px;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
        letter-spacing: 2px;
        border-radius: 4px;
        text-align: center;
    }
}
</style>
